import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="hover-preview"
export default class extends Controller {
  static targets = ["trigger", "popup", "card"]
  static values = { delay: { type: Number, default: 1000 } }

  connect() {
    this.currentIndex = 0
    this.interval = null
    this.fadeTimeout = null
    this.isVisible = false
    
    if (this.hasPopupTarget) {
      this.popupTarget.classList.add("hidden")
      this.popupTarget.classList.remove("block")
    }
  }

  disconnect() {
    this.clearSlideshow()
    
    this.isVisible = false
    if (this.hasPopupTarget) {
      this.popupTarget.classList.add("hidden")
      this.popupTarget.classList.remove("block")
    }
  }

  showPopup() {
    if (this.isVisible) return
    
    this.isVisible = true
    this.popupTarget.classList.remove("hidden")
    this.popupTarget.classList.add("block")
    
    this.waitForCardsAndStartSlideshow()
  }

  hidePopup() {
    if (!this.isVisible) return
    
    this.isVisible = false
    this.popupTarget.classList.add("hidden")
    this.popupTarget.classList.remove("block")
    this.clearSlideshow()
  }

  waitForCardsAndStartSlideshow() {
    if (!this.isVisible) return
    
    if (this.cardTargets.length === 0) {
      setTimeout(() => {
        this.waitForCardsAndStartSlideshow()
      }, 100)
      return
    }

    this.setupCards()

    if (this.isVisible) {
      this.startSlideshow()
    }
  }

  setupCards() {
    if (this.cardTargets.length === 0) return

    this.cardTargets.forEach((card, index) => {
      card.style.position = "absolute"
      card.style.top = "0"
      card.style.left = "0"
      card.style.width = "100%"
      // First card on top and visible, others behind and hidden
      card.style.zIndex = index === 0 ? "2" : "1"
      card.style.opacity = index === 0 ? "1" : "0"
    })
  }

  startSlideshow() {
    if (this.cardTargets.length <= 1) return

    this.clearSlideshow()

    this.interval = setInterval(() => {
      if (this.isVisible) {
        this.showNextCard()
      }
    }, this.delayValue)
  }

  showNextCard() {
    if (this.cardTargets.length <= 1) return

    if (this.fadeTimeout) {
      clearTimeout(this.fadeTimeout)
      this.fadeTimeout = null
    }

    const previousIndex = this.currentIndex
    this.currentIndex = (this.currentIndex + 1) % this.cardTargets.length

    const newCard = this.cardTargets[this.currentIndex]
    const oldCard = this.cardTargets[previousIndex]

    // Bring new card to front and fade it in
    newCard.style.zIndex = "2"
    newCard.style.opacity = "1"

    // Keep old card visible behind during transition, then hide after fade completes
    oldCard.style.zIndex = "1"
    this.fadeTimeout = setTimeout(() => {
      oldCard.style.opacity = "0"
      this.fadeTimeout = null
    }, 300)
  }

  clearSlideshow() {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }

    if (this.fadeTimeout) {
      clearTimeout(this.fadeTimeout)
      this.fadeTimeout = null
    }

    this.currentIndex = 0
  }
}
